import { render, staticRenderFns } from "./ShopStorePayHuifu.vue?vue&type=template&id=627692a6&scoped=true"
import script from "./ShopStorePayHuifu.vue?vue&type=script&lang=js"
export * from "./ShopStorePayHuifu.vue?vue&type=script&lang=js"
import style0 from "./ShopStorePayHuifu.vue?vue&type=style&index=0&id=627692a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627692a6",
  null
  
)

export default component.exports